"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementSize = exports.updateAllElementsSizes = void 0;

var react_1 = require("react");

var elementSizeHooks = [];

var updateAllElementsSizes = function updateAllElementsSizes() {
  var _iterator = _createForOfIteratorHelper(elementSizeHooks),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var listener = _step.value;
      listener();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

exports.updateAllElementsSizes = updateAllElementsSizes;

var useElementSize = function useElementSize(ref, options) {
  var _ref = (0, react_1.useState)(null),
      _ref2 = _slicedToArray(_ref, 2),
      size = _ref2[0],
      setSize = _ref2[1];

  var observer = (0, react_1.useMemo)(function () {
    if (typeof ResizeObserver === 'undefined') {
      return null;
    }

    return new ResizeObserver(function (entries) {
      // The contentRect returns the width without any `scale()`'s being applied. The height is wrong
      var contentRect = entries[0].contentRect; // The clientRect returns the size with `scale()` being applied.

      var newSize = entries[0].target.getClientRects();

      if (!newSize || !newSize[0]) {
        setSize(null);
        return;
      }

      var probableCssParentScale = newSize[0].width / contentRect.width;
      var width = options.shouldApplyCssTransforms ? newSize[0].width : newSize[0].width * (1 / probableCssParentScale);
      var height = options.shouldApplyCssTransforms ? newSize[0].height : newSize[0].height * (1 / probableCssParentScale);
      setSize({
        width: width,
        height: height,
        left: newSize[0].x,
        top: newSize[0].y,
        windowSize: {
          height: window.innerHeight,
          width: window.innerWidth
        }
      });
    });
  }, [options.shouldApplyCssTransforms]);
  var updateSize = (0, react_1.useCallback)(function () {
    if (!ref.current) {
      return;
    }

    var rect = ref.current.getClientRects();

    if (!rect[0]) {
      setSize(null);
      return;
    }

    setSize({
      width: rect[0].width,
      height: rect[0].height,
      left: rect[0].x,
      top: rect[0].y,
      windowSize: {
        height: window.innerHeight,
        width: window.innerWidth
      }
    });
  }, [ref]);
  (0, react_1.useEffect)(function () {
    if (!observer) {
      return;
    }

    updateSize();
    var current = ref.current;

    if (ref.current) {
      observer.observe(ref.current);
    }

    return function () {
      if (current) {
        observer.unobserve(current);
      }
    };
  }, [observer, ref, updateSize]);
  (0, react_1.useEffect)(function () {
    if (!options.triggerOnWindowResize) {
      return;
    }

    window.addEventListener('resize', updateSize);
    return function () {
      window.removeEventListener('resize', updateSize);
    };
  }, [options.triggerOnWindowResize, updateSize]);
  (0, react_1.useEffect)(function () {
    elementSizeHooks.push(updateSize);
    return function () {
      elementSizeHooks = elementSizeHooks.filter(function (e) {
        return e !== updateSize;
      });
    };
  }, [updateSize]);
  return size;
};

exports.useElementSize = useElementSize;